export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-CreateBasicTaskWizard01.03b133bf.png";